import { z } from 'zod';
import { product } from './Product';
import { categoryFilter } from './CategoryFilter';

export const productGroupByCategory = z.object({
    categoryFilter: categoryFilter.nullable(),
    products: z.array(product)
});

export type ProductGroupByCategory = z.infer<typeof productGroupByCategory>;
